var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector408Stroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7071 0.792893C17.0976 1.18342 17.0976 1.81658 16.7071 2.20711L8.12132 10.7929C6.94975 11.9645 5.05026 11.9645 3.87868 10.7929L0.292893 7.20711C-0.0976311 6.81658 -0.0976311 6.18342 0.292893 5.79289C0.683417 5.40237 1.31658 5.40237 1.70711 5.79289L5.29289 9.37868C5.68342 9.7692 6.31658 9.76921 6.70711 9.37868L15.2929 0.792893C15.6834 0.402369 16.3166 0.402369 16.7071 0.792893Z",
    fill: "#83BF6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector408Stroke);
export default __webpack_public_path__ + "static/media/Vector 408 (Stroke).04fe0631113ee43b2291104619684256.svg";
export { ForwardRef as ReactComponent };